import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import mattressIpsum from 'mattress-ipsum';
import { Collapse, Button } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  mattressIpsum,
  Collapse,
  Button,
  React
};